// Utils
import registerClone from '../../../common/clone/index';
import component from './Clone';

// Constants
import { TOOLS } from '../../workspace/toolbar/toolbarConstants';

export default () =>
    registerClone({
        containerComponent: component,
        presentationalComponent: component,
        tools: [TOOLS.COLOR, TOOLS.ICON],
        showTool: false,
    });
